import { FC } from 'react'

import { useSelector } from 'react-redux'
import styled from 'styled-components'

import Logo from 'src/Assets/Svg/Logo/Logo.svg?react'
import LogoTextBlack from 'src/Assets/Svg/Logo/LogoTextBlack.svg?react'
import LogoTextWhite from 'src/Assets/Svg/Logo/LogoText.svg?react'
import { getResolvedTheme } from 'src/Redux/theme-process'
import { MAX_MOBILE_WIDTH, MAX_TABLET_WIDTH } from 'src/Styled/variables'

const Container = styled.div<{
  withShadow: boolean
}>`
  display: flex;
  width: 100%;
  height: 72px;
  padding: 16px;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.color.white};
  grid-area: header;
  box-shadow: ${({ withShadow, theme }) =>
    withShadow ? theme.shadow.header : 'none'};
  transition: box-shadow 0.3s ease-in-out;
  z-index: 1;

  @media (max-width: ${MAX_TABLET_WIDTH}) {
    padding: 16px 24px;
  }

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    padding: 16px;
  }
`

const Link = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
`

export interface CreateCampaignHeaderProps {
  withShadow: boolean
  logoLinkUrl?: string
}

export const CreateCampaignHeader: FC<CreateCampaignHeaderProps> = ({
  withShadow,
  logoLinkUrl,
}) => {
  const theme = useSelector(getResolvedTheme)
  const LogoText = theme === 'dark' ? LogoTextWhite : LogoTextBlack

  return (
    <Container withShadow={withShadow}>
      <Link target='_blank' rel='noopener noreferrer' href={logoLinkUrl}>
        <Logo />
        <LogoText />
      </Link>
    </Container>
  )
}
